import moment from 'moment';
import React from 'react';
import Button from '../Button';
import colours from '../Colours';
import Icon from '../Icons/Icon';
import { CaptionMedium, CaptionSmall, P3, P3Bold, P4 } from '../Text';
import { connect } from "react-redux";
import axios from 'axios';
import { openPullout, setOverlay } from '../../../../Actions/stakeholderActions';
import { checkCredentials } from '../../../../Helpers/checkCredentials';
import { setProfileDb } from "../../../../Actions/dataActions";
import { VCIcon, DivisionIcon } from '../../../Common/Buttons/TypeIcons';

const UserStatusCard = (props) => {
    const onRelease = (e, book_id) => {
        if (props.closeModal) props.closeModal();
        e.stopPropagation();
        const newurl = props.match.url.split('/', 3)[1];
        props.history.push(`${newurl}/release/${book_id}`);
    }

    const onReturn = (e, book_id) => {
        if (props.closeModal) props.closeModal();
        e.stopPropagation();
        props.history.push(`${props.match.url}/return/${book_id}`);
    }

    // const onDeactivate = (e) => {
    //     e.stopPropagation();

    //     props.history.push(props.match.url + '/deactivateprofile/' + props.match.params.profile_id);
    // }

    // const onReactivate = (e) => {
    //     e.stopPropagation();

    //     axios.post('/ajax/profile/' + props.user?.profile?.ID + '/activate')
    //     .then(function(response) {
    //         checkCredentials(response);
    //         showStatusMsg(response?.data.message, 'success');

    //         axios.get('/ajax/profile/' + props.user?.profile?.ID)
    //         .then(function(response2) {
    //             props.dispatch(setProfileDb([response2.data.profile], props.data.profile_db))
    //             props.dispatch(setOverlay("SET_CURRENT_PROFILE_DETAILS", response2.data))
    //         })
    //     })
    //     .catch(function(error) {
    //         if(error.response?.status == 401){
    //             showStatusMsg(error.response?.data.error);
    //         } else if(error.response?.status == 422) {
    //             var error_message = "";

    //             $.each(error.response?.data.errors, function (index, element) {
    //                 error_message += element + '<br />';
    //             });

    //             showStatusMsg(error_message);
    //         } else {
    //             showStatusMsg("Requested information not found");
    //         }
    //     })
    // }

    const onApprove = (e) => {
        e.stopPropagation();

        axios.post('/ajax/profile' + '/' + props.user?.profile?.ID + '/approve')
        .then((response)=> {
            axios.get('/ajax/profile/' + props.user?.profile?.ID)
            .then(function(response2) {
                props.dispatch(setOverlay("SET_CURRENT_PROFILE_DETAILS", response2.data))
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        })
    }

    const onReject = (e) => {
        if (props.closeModal) props.closeModal();
        e.stopPropagation();
        props.history.push(props.match.url + '/rejectuser/' + props.user?.profile?.ID);
    }

    const getCurrentBooking = () => {
        let result = null;

        if (props.user.bookings && props.user.bookings.current && props.user.bookings.current.length > 0) {
            props.user.bookings.current.map((booking)=> {
                if (moment().isAfter(booking.Start_Date) && moment().isBefore(booking.End_Date)) {
                    result = booking;
                }
            })
        }
        return result;
    }

    let user = props.user;

    let data = {
        container: {
            booking: 'ds-statuscard-container-blue',
            invited: 'ds-statuscard-container-blue',
            tag: 'ds-statuscard-container-blue',
            active: 'ds-statuscard-container-green',
            request: 'ds-statuscard-container-yellow',
            rejected: 'ds-statuscard-container-red',
            deactivated: 'ds-statuscard-container-grey'
        },
        header: {
            booking: 'ds-statuscard-header-blue',
            invited: 'ds-statuscard-header-blue',
            tag: 'ds-statuscard-header-blue',
            active: 'ds-statuscard-header-green',
            request: 'ds-statuscard-header-yellow',
            rejected: 'ds-statuscard-header-red',
            deactivated: 'ds-statuscard-header-grey'
        },
        headerText: {
            booking: "ON A BOOKING",
            invited: "INVITED", 
            tag: "INTERNAL TAG",
            active: "ACTIVE",
            request: "REQUEST",
            rejected: "REJECTED",
            deactivated: "DEACTIVATED"
        },
        headerButton: {
            booking: <Button small tertiary leading_ic="Edit" label="Edit" onClick={()=>{props.dispatch(openPullout(getCurrentBooking()))}} color={colours.primary.white}/>,
            // active: <Button small tertiary leading_ic="UserDeactivate" label="Deactivate User" onClick={(e)=>{onDeactivate(e)}} color={colours.primary.white}/>,
            
        },
        renderContent: {
            booking: <BookingContent data={user} onRelease={onRelease} onReturn={onReturn}/>,
            invited: <InvitedContent data={user}/>,
            tag: <TagContent data={user} onRelease={onRelease} onReturn={onReturn}/>,
            active: <ActiveContent data={user}/>,
            request: <RequestContent data={user} onApprove={onApprove} onReject={onReject}/>,
            rejected: <RejectedContent data={user} onApprove={onApprove}/>,
            deactivated: <DeactivatedContent data={user}/>
        }
    }

    let type = '';

    //determine status card type with the following checks:
    if (! props.active) {
        if (user.status && user.status == 'Pending') {
            type = 'request';
        } else if (user.status && user.status == "Rejected") {
            type = 'rejected';
        } else if (user.status && user.status == 'Inactive') {
            type = 'deactivated';
        } else if (user.status && user.status == 'Invited') {
            type = 'invited';
        } else if (user.status && user.status == 'Internal Tag') {
            type = 'tag';
        } else if (user.bookings && user.bookings.current && user.bookings.current.length > 0) {
            user.bookings.current.map((booking) => {
                if (moment().isAfter(booking.Start_Date) && moment().isBefore(booking.End_Date)) {
                    type = 'booking';
                }
            })
        } else if (user.bookings && user.bookings.length > 0) {
            user.bookings.map((booking) => {
                if (booking.Start_Date) {
                    if (moment().isAfter(booking.Start_Date) && moment().isBefore(booking.End_Date)) {
                        type = 'booking';
                    }
                }
            })
        }
    } else {
        if ((user.status
            && (user.status !== 'Pending'
            && user.status !== 'Rejected'
            && user.status !== 'Invited'
            && user.status !== 'Inactive'
            && user.status !== 'Internal Tag')
            || user.status == 'Active'
            ) || (!user.status && (user.Active == 1))){
            type = 'active';
        }
    }
    

    if (type !== '') {
        return (
            <div className={"ds-statuscard-container " + data.container[type]}>
                <div className={"ds-statuscard-header " + data.header[type]}>
                    <P3Bold style={{color: (type == 'request') ? colours.primary.grey01 : colours.primary.white}}>
                        {data.headerText[type]}
                    </P3Bold>
                    {data.headerButton[type]}
                </div>
                {data.renderContent[type]}
            </div>
            )
    } else return null;
}

const BookingContent = (props) => {
    let data = props.data;
    let currentBooking = null;
    data.bookings.current.map((booking) => {
        if (moment().isAfter(booking.Start_Date) && moment().isBefore(booking.End_Date)) {
            currentBooking = booking;
        } 
    });

    let releaseIconContainerStyle = { borderRadius: '8px', color: colours.primary.grey03, backgroundColor: colours.primary.grey05};
    let returnIconContainerStyle = { borderRadius: '8px', color: colours.primary.grey03, backgroundColor: colours.primary.grey05};
    if (currentBooking.Released_On) {
        releaseIconContainerStyle = { borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue};
        
        if (currentBooking.Returned_On) {
            returnIconContainerStyle = { borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue};
        }
    }

    if (currentBooking !== null) {
        return (
            <div className="ds-statuscard-content">
               <div className="ds-statuscard-content-row-space-between mt-4">
                   <div className="ds-statuscard-content-row">
                        <div className="ds-statuscard-icon">
                            <Icon name="Release" size={24} style={releaseIconContainerStyle}/>
                        </div>
                        <div>
                            <CaptionSmall>RELEASE</CaptionSmall>
                            <P3Bold>{moment(currentBooking.Start_Date).format('MMM DD, YYYY')}</P3Bold>
                        </div>
                   </div>
                   <div className="ds-statuscard-content-row">
                        <div className="ds-statuscard-icon">
                            <Icon name="CheckIn" size={24} style={returnIconContainerStyle}/>
                        </div>
                        <div>
                            <CaptionSmall>RETURN</CaptionSmall>
                            <P3Bold>{moment(currentBooking.End_Date).format('MMM DD, YYYY')}</P3Bold>
                        </div>
                   </div>
                </div>
                {currentBooking.vehicle ? 
                <>
                    <div className="ds-statuscard-content-row mt-8">
                        <P3Bold>{currentBooking.vehicle.Year + " " + currentBooking.vehicle.Make + " " + currentBooking.vehicle.Model}</P3Bold>
                    </div>
                    <div className="ds-statuscard-content-row">
                        <P4 style={{color: colours.primary.grey02}}>{currentBooking.vehicle.VIN}</P4>
                    </div>
                </> : null}
                {currentBooking.stakeholder ? 
                <>
                <div className="ds-statuscard-content-row-space-between mt-8">
                    <P4 style={{color: colours.primary.grey02, flex: 1}}>POOL:</P4>
                    <div className="ds-statuscard-content-row">
                        {/* <Icon name="CheckIn" size={18} />
                        <P3Bold>{currentBooking.vehicle.stakeholder.Division}</P3Bold> */}
                        <div className="overlay_header_info_access_item" style={{alignItems: 'center'}}>{DivisionIcon(currentBooking.stakeholder, null, null, null, true)}<P3Bold>{currentBooking.stakeholder.Division} Division</P3Bold></div>
                    </div>
                </div>
                <div className="ds-statuscard-content-row-space-between mt-4">
                    <P4 style={{color: colours.primary.grey02, flex: 1}}>FACILITY:</P4>
                    <div className="ds-statuscard-content-row">
                        {/* <Icon name="CheckIn" size={18} />
                        <P3Bold>{currentBooking.vehicle.vmh.Display_Name + " - " + currentBooking.vehicle.vmh.Display_City}</P3Bold> */}
                        <div className="overlay_header_info_access_item" style={{alignItems: 'center'}}>{VCIcon(currentBooking.vehicle.vmh, null, null, null, true)}<P3Bold>{currentBooking.vehicle.vmh.Display_Name + " - " + currentBooking.vehicle.vmh.Display_City}</P3Bold></div>
                    </div>
                </div>
                </> : null}
                <div className="ds-statuscard-button-row">
                    {currentBooking.Released_On ? 
                       <Button tertiary small label="Release Information" onClick={(e) => {props.onRelease(e,currentBooking.BOOK_ID)}}/> 
                    : <Button secondary small label="Release" onClick={(e) => {props.onRelease(e,currentBooking.BOOK_ID)}}/>}
                    {currentBooking.Returned_On ? 
                    <Button tertiary small label="Check In Information" onClick={() => {props.onReturn(currentBooking.BOOK_ID)}}/>
                    : <Button secondary small label="Check In" onClick={() => {props.onReturn(currentBooking.BOOK_ID)}}/>}
                </div>
            </div>
        )
    } else {
        return null;
    }
}

const InvitedContent = ({data}) => {
    let requestIconContainerStyle = { marginRight: 4, borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue};
    let inviteDate = data.profile.invite[0].Created_At;
    let invitedBy = data.profile.invite[0].invited_by;

    return (
        <div className="ds-statuscard-content">
           <div className="ds-statuscard-content-row-space-between">
                <div className="ds-statuscard-content-row mt-4">
                    <Icon name="UserRequest" style={requestIconContainerStyle} size={24}/>
                    <CaptionMedium style={{color: colours.primary.grey02}}>INVITE DATE:</CaptionMedium> 
                </div>
                <div className="ds-statuscard-content-row mt-8">
                    <P3Bold>{moment(inviteDate).format('MMM DD, YYYY')}</P3Bold> 
                </div>
            </div>
            <div className="ds-statuscard-content-row-space-between">
                <div className="ds-statuscard-content-row" style={{marginTop: 4}}>
                    <Icon name="UserRequest" style={requestIconContainerStyle} size={24}/>
                    <CaptionMedium style={{color: colours.primary.grey02}}>INVITED BY:</CaptionMedium> 
                </div>
                <div className="ds-statuscard-content-row" style={{marginLeft: 8}}>
                    <P3Bold>{invitedBy?.First_Name + " " + invitedBy?.Last_Name}</P3Bold> 
                </div>
            </div>
        </div>
    )
}

const ActiveContent = ({data}) => {
    let upcoming = null;
    let upcomingIconContainerStyle = { marginRight: 4, borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue};
    let hasActiveBooking = false;

    if (data.bookings && data.bookings.current && data.bookings.current.length > 0) {
        data.bookings.current.map((booking) => {
            if ((moment().isAfter(booking.Start_Date)) && (moment().isBefore(booking.End_Date))){
                hasActiveBooking = true;
            }})
    } 
    if (!hasActiveBooking && data.bookings && data.bookings.upcomming && data.bookings.upcomming.length > 0) {
        upcoming = data.bookings.upcomming[0];
    }
        if ((upcoming !== null) && (!hasActiveBooking)) {
            return (
                <div className="ds-statuscard-content">
                    <div className="ds-statuscard-content-row-space-between">
                        <div className="ds-statuscard-content-row mt-4">
                            <Icon name="Upcoming" style={upcomingIconContainerStyle} size={24}/>
                            <CaptionMedium style={{color: colours.primary.grey02, width: 50 }}>UPCOMING BOOKING:</CaptionMedium> 
                        </div>
                        <div className="ds-statuscard-content-row mt-8">
                            <P3Bold>{moment(upcoming.Start_Date).format('MMM DD, YYYY')}</P3Bold> 
                        </div>
                    </div>
                    {upcoming.vehicle && 
                    <>
                        <div className="ds-statuscard-content-row mt-8">
                            <P3Bold>{upcoming.vehicle.Year + " " + upcoming.vehicle.Make + " " + upcoming.vehicle.Model}</P3Bold>
                        </div>
                        <div className="ds-statuscard-content-row">
                            <P4 style={{color: colours.primary.grey02}}>{upcoming.vehicle.VIN}</P4>
                        </div>
                        <div className="ds-statuscard-content-row-space-between mt-8">
                            <P4 style={{color: colours.primary.grey02, flex: 1}}>POOL:</P4>
                            <div className="ds-statuscard-content-row">
                                {/* <Icon name="CheckIn" size={18} />
                                <P3Bold>{upcoming.vehicle.stakeholder.Division}</P3Bold> */}
                                <div className="overlay_header_info_access_item" style={{alignItems: 'center'}}>{DivisionIcon(upcoming.stakeholder, null, null, null, true)}<P3Bold>{upcoming.stakeholder.Division} Division</P3Bold></div>
                            </div>
                        </div>
                        <div className="ds-statuscard-content-row-space-between mt-4">
                            <P4 style={{color: colours.primary.grey02, flex: 1}}>FACILITY:</P4>
                            <div className="ds-statuscard-content-row">
                                {/* <Icon name="CheckIn" size={18} />
                                <P3Bold>{upcoming.vehicle.vmh.Display_Name + " - " + upcoming.vehicle.vmh.Display_City}</P3Bold> */}
                                <div className="overlay_header_info_access_item" style={{alignItems: 'center'}}>{VCIcon(upcoming.vehicle.vmh, null, null, null, true)}<P3Bold>{upcoming.vehicle.vmh.Display_Name + " - " + upcoming.vehicle.vmh.Display_City}</P3Bold></div>
                            </div>
                        </div>
                    </>}
                </div>
            )
        } else return null;
}

const RequestContent = (props) => {
    let data = props.data;
    let requestIconContainerStyle = { marginRight: 4, borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue};
    let foundDate = false;
    let requestDate = data.profile.sh_requests.map((request) => {
        if (!foundDate && (request.Active == 1 && request.Status == 1)) {
            foundDate = true;
            return request.Created_At;
        } else return null;
    });
    return (
        <div className="ds-statuscard-content">
           <div className="ds-statuscard-content-row-space-between mt-4">
                <div className="ds-statuscard-content-row">
                    <Icon name="UserRequest" style={requestIconContainerStyle} size={24}/>
                    <CaptionMedium style={{color: colours.primary.grey02}}>REQUEST DATE:</CaptionMedium> 
                </div>
                <div className="ds-statuscard-content-row mt-8">
                    <P3Bold>{moment(requestDate).format('MMM DD, YYYY')}</P3Bold> 
                </div>
            </div>
            <div className="ds-statuscard-button-row">
                <Button secondary small label="Reject" leading_ic="UserReject" color={colours.accent.error_red} onClick={(e)=> {props.onReject(e)}}/>
                <Button secondary small label="Approve" leading_ic="UserApprove" color={colours.accent.validate_green} onClick={(e)=> {props.onApprove(e)}}/>
            </div>
        </div>
    )
}

const RejectedContent = ({data}) => {
    let iconContainerStyle = { marginRight: 4, borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue};
    let found = false;

    let renderData = data.profile?.sh_requests.map((request) => {
        if (request.Active == 1 && request.Status == 3 && !found && request.Rejected_At !== null) {
            found = true;
            return (
                <div className="ds-statuscard-content">
                   <div className="ds-statuscard-content-row-space-between mt-4">
                        <div className="ds-statuscard-content-row">
                            <Icon name="Calendar" style={iconContainerStyle} size={24}/>
                            <CaptionMedium style={{color: colours.primary.grey02, width: 50}}>REJECTION DATE:</CaptionMedium> 
                        </div>
                        <div className="ds-statuscard-content-row">
                            <P3Bold>{moment(request.Rejected_At).format('MMM DD, YYYY')}</P3Bold> 
                        </div>
                    </div>
                    <div className="ds-statuscard-content-row-space-between mt-8">
                        <div className="ds-statuscard-content-row">
                            <Icon name="User" style={iconContainerStyle} size={24}/>
                            <CaptionMedium style={{color: colours.primary.grey02}}>REJECTED BY:</CaptionMedium> 
                        </div>
                        <div className="ds-statuscard-content-row">
                            <P3Bold>{request.rejected_by?.profile?.First_Name + " " + request.rejected_by?.profile?.Last_Name}</P3Bold> 
                        </div>
                    </div>
                    <div className="ds-statuscard-content-row mt-8">
                        <P3>{request.Rejection_Notes}</P3>
                    </div>
                    {/* <div className="ds-statuscard-button-row-centered">
                        <Button secondary small label="Invite User" onClick={()=> {}}/>
                    </div> */}
                </div>
            )
        }
    })
    return (renderData ? renderData: null);
}

const DeactivatedContent = (props) => {
    let data = props.data;
    let iconContainerStyle = { marginRight: 4, borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue};
    let profile = data.profile.sh_vmh_access.map((item) => {
        if (item.Active == 0) {
            return item;
        }
    })[0];

    return (
        <div className="ds-statuscard-content">
            <div className="ds-statuscard-content-row-space-between mt-4">
                <div className="ds-statuscard-content-row">
                    <Icon name="Calendar" style={iconContainerStyle} size={24}/>
                    <CaptionMedium style={{color: colours.primary.grey02, width: 50}}>DEACTIVATION DATE:</CaptionMedium> 
                </div>
                <div className="ds-statuscard-content-row">
                    <P3Bold>{moment(profile.Removed_At, 'YYYY-MM-DD').format('MMM DD, YYYY')}</P3Bold> 
                </div>
            </div>
            <div className="ds-statuscard-content-row-space-between mt-8">
                <div className="ds-statuscard-content-row">
                    <Icon name="User" style={iconContainerStyle} size={24}/>
                    <CaptionMedium style={{color: colours.primary.grey02}}>DEACTIVATED BY:</CaptionMedium> 
                </div>
                <div className="ds-statuscard-content-row" >
                    <P3Bold>Profile {profile.Removed_By}</P3Bold> 
                </div>
            </div>
            <div className="ds-statuscard-content-row mt-8">
                <P3>{profile.Removal_Notes}</P3>
            </div>
            {/* <div className="ds-statuscard-button-row-centered">
                <Button secondary small label="Reactivate" leading_ic="UserApprove" color={colours.accent.validate_green} onClick={(e)=> {props.onReactivate(e)}}/>
            </div> */}
        </div>
    )
}

const TagContent = (props) => {
    let data = props.data;
    let upcoming = null;
    let currentBooking = null;
    let iconContainerStyle = { marginRight: 4, borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue};
    let hasActiveBooking = false;
    let releaseIconContainerStyle = { borderRadius: '8px', color: colours.primary.grey03, backgroundColor: colours.primary.grey05};
    let returnIconContainerStyle = { borderRadius: '8px', color: colours.primary.grey03, backgroundColor: colours.primary.grey05};
    
    

    if (data.bookings && data.bookings.current && data.bookings.current.length > 0) {
        data.bookings.current.map((booking) => {
            if ((moment().isAfter(booking.Start_Date)) && (moment().isBefore(booking.End_Date))){
                currentBooking = booking;
                hasActiveBooking = true;
            }})
    } 
    if (!hasActiveBooking && data.bookings && data.bookings.upcomming && data.bookings.upcomming.length > 0) {
        upcoming = data.bookings.upcomming[0];
    }

    if (currentBooking && currentBooking.Released_On) {
        releaseIconContainerStyle = { borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue};
        
        if (currentBooking && currentBooking.Returned_On) {
            returnIconContainerStyle = { borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue};
        }
    }

        if ((upcoming !== null) && (!hasActiveBooking)) {
            return (
                <div className="ds-statuscard-content">
                    <div className="ds-statuscard-content-row-space-between">
                        <div className="ds-statuscard-content-row mt-4">
                            <Icon name="Upcoming" style={iconContainerStyle} size={24}/>
                            <CaptionMedium style={{color: colours.primary.grey02, width: 50 }}>UPCOMING BOOKING:</CaptionMedium> 
                        </div>
                        <div className="ds-statuscard-content-row mt-8">
                            <P3Bold>{moment(upcoming.Start_Date).format('MMM DD, YYYY')}</P3Bold> 
                        </div>
                    </div>
                    {upcoming.vehicle && 
                    <>
                        <div className="ds-statuscard-content-row mt-8">
                            <P3Bold>{upcoming.vehicle.Year + " " + upcoming.vehicle.Make + " " + upcoming.vehicle.Model}</P3Bold>
                        </div>
                        <div className="ds-statuscard-content-row">
                            <P4 style={{color: colours.primary.grey02}}>{upcoming.vehicle.VIN}</P4>
                        </div>
                        <div className="ds-statuscard-content-row-space-between mt-8">
                            <P4 style={{color: colours.primary.grey02, flex: 1}}>POOL:</P4>
                            {/* <div className="ds-statuscard-content-row">
                                <Icon name="CheckIn" size={18} />
                                <P3Bold>{upcoming.vehicle.stakeholder.Division}</P3Bold>
                            </div> */}
                            <div className="overlay_header_info_access_item" style={{alignItems: 'center'}}>{DivisionIcon(upcoming.stakeholder, null, null, null, true)}<P3Bold>{upcoming.stakeholder.Division} Division</P3Bold></div>
                        </div>
                        <div className="ds-statuscard-content-row-space-between mt-4">
                            <P4 style={{color: colours.primary.grey02, flex: 1}}>FACILITY:</P4>
                            <div className="ds-statuscard-content-row">
                                {/* <Icon name="CheckIn" size={18} />
                                <P3Bold>{upcoming.vehicle.vmh.Display_Name + " - " + upcoming.vehicle.vmh.Display_City}</P3Bold> */}
                                <div className="overlay_header_info_access_item" style={{alignItems: 'center'}}>{VCIcon(upcoming.vehicle.vmh, null, null, null, true)}<P3Bold>{upcoming.vehicle.vmh.Display_Name + " - " + upcoming.vehicle.vmh.Display_City}</P3Bold></div>
                            </div>
                        </div>
                    </>}
                </div>
            )
        } else if (currentBooking !== null) {
            return (
                <div className="ds-statuscard-content">
                   <div className="ds-statuscard-content-row-space-between mt-4">
                       <div className="ds-statuscard-content-row">
                            <div className="ds-statuscard-icon">
                                <Icon name="Release" size={24} style={releaseIconContainerStyle}/>
                            </div>
                            <div>
                                <CaptionSmall>RELEASE</CaptionSmall>
                                <P3Bold>{moment(currentBooking.Start_Date).format('MMM DD, YYYY')}</P3Bold>
                            </div>
                       </div>
                       <div className="ds-statuscard-content-row">
                            <div className="ds-statuscard-icon">
                                <Icon name="CheckIn" size={24} style={returnIconContainerStyle}/>
                            </div>
                            <div>
                                <CaptionSmall>RETURN</CaptionSmall>
                                <P3Bold>{moment(currentBooking.End_Date).format('MMM DD, YYYY')}</P3Bold>
                            </div>
                       </div>
                    </div>
                    <div className="ds-statuscard-content-row mt-8">
                        <P3Bold>{currentBooking.vehicle.Year + " " + currentBooking.vehicle.Make + " " + currentBooking.vehicle.Model}</P3Bold>
                    </div>
                    <div className="ds-statuscard-content-row">
                        <P4 style={{color: colours.primary.grey02}}>{currentBooking.vehicle.VIN}</P4>
                    </div>
                    <div className="ds-statuscard-content-row-space-between mt-8">
                        <P4 style={{color: colours.primary.grey02, flex: 1}}>POOL:</P4>
                        <div className="ds-statuscard-content-row">
                            {/* <Icon name="CheckIn" size={18} />
                            <P3Bold>{currentBooking.vehicle.stakeholder.Division}</P3Bold> */}
                            <div className="overlay_header_info_access_item" style={{alignItems: 'center'}}>{DivisionIcon(currentBooking.stakeholder, null, null, null, true)}<P3Bold>{currentBooking.stakeholder.Division} Division</P3Bold></div>
                        </div>
                    </div>
                    <div className="ds-statuscard-content-row-space-between mt-4">
                        <P4 style={{color: colours.primary.grey02, flex: 1}}>FACILITY:</P4>
                        <div className="ds-statuscard-content-row">
                            {/* <Icon name="CheckIn" size={18} />
                            <P3Bold>{currentBooking.vehicle.vmh.Display_Name + " - " + currentBooking.vehicle.vmh.Display_City}</P3Bold> */}
                            <div className="overlay_header_info_access_item" style={{alignItems: 'center'}}>{VCIcon(currentBooking.vehicle.vmh, null, null, null, true)}<P3Bold>{currentBooking.vehicle.vmh.Display_Name + " - " + currentBooking.vehicle.vmh.Display_City}</P3Bold></div>
                        </div>
                    </div>
                    <div className="ds-statuscard-button-row">
                        {currentBooking.Released_On ? 
                           <Button tertiary small label="Release Information" onClick={(e)=> {props.onRelease(e,currentBooking.BOOK_ID)}}/> 
                        : <Button secondary small label="Release" onClick={(e)=> {props.onRelease(e,currentBooking.BOOK_ID)}}/>}
                        {currentBooking.Returned_On ? 
                        <Button tertiary small label="Check In Information" onClick={(e)=> {props.onReturn(e,currentBooking.BOOK_ID)}}/>
                        : <Button secondary small label="Check In" onClick={(e)=> {props.onReturn(e,currentBooking.BOOK_ID)}}/>}
                    </div>
                </div>
            )
        } else return null;
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    stakeholder: store.stakeholder
})

export default connect(mapStateToProps)(UserStatusCard);